export interface ICaseSelect {
    player: string;
    guests: number;
}
/* eslint-disable @typescript-eslint/no-explicit-any */
export const casesGhost = {
    '0': [
        { player: 'David Benítez', guests: 2 },
        { player: 'Pedro Castillo', guests: 0 },
    ],
    '1': [{ player: 'Iván Castro', guests: 1 }],
    '2': [{ player: 'Adam Contreras', guests: 2 }],
    '3': [
        { player: 'Manuel Díaz', guests: 2 },
        { player: 'Martín Duarte', guests: 1 },
    ],
    '4': [
        { player: 'Nicolás Espinoza', guests: 0 },
        { player: 'Jorge Fernández', guests: 3 },
    ],
    '5': [
        { player: 'Javier Flores', guests: 1 },
        { player: 'David García', guests: 0 },
        { player: 'Diego Giménez', guests: 0 },
    ],
    '6': [
        { player: 'Mario Gómez', guests: 1 },
        { player: 'Lucas Hernández', guests: 0 },
        { player: 'Carlos Jiménez', guests: 1 },
    ],
    '7': [
        { player: 'Miguel López', guests: 1 },
        { player: 'Douglas Martínez', guests: 0 },
    ],
    '8': [
        { player: 'Jean Mejía', guests: 0 },
        { player: 'Franco Morales', guests: 2 },
    ],
    '9': [
        { player: 'Jose Moreno', guests: 1 },
        { player: 'Agustin Muñoz', guests: 2 },
    ],
    A: [
        { player: 'Alexis Pineda', guests: 1 },
        { player: 'Asdrubal Portillo', guests: 2 },
    ],
    B: [
        { player: 'Richard Quispe', guests: 0 },
        { player: 'Wiliam Ramírez', guests: 1 },
    ],
    C: [
        { player: 'Egard Reyes', guests: 0 },
        { player: 'Samuel Santos', guests: 1 },
        { player: 'Fabian Torres', guests: 0 },
    ],
    D: [
        { player: 'Juan Soto', guests: 1 },
        { player: 'Joel Villalba', guests: 2 },
    ],
    E: [
        { player: 'Sabino Marquez', guests: 2 },
        { player: 'Pierre Cisneros', guests: 1 },
    ],
    F: [
        { player: 'Cleiver Zambrano', guests: 1 },
        { player: 'Luis Vera', guests: 0 },
    ],
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getTeamIdToJoin = (game, ghost, i) => {
    const maxCapacity = game?.maxCapacity / 2;
    const random = i % 2;

    if (random) {
        const countTeamA = game.gamePlayers.filter((obj: any) => obj.teamId === game.teamIdA).length;

        if (countTeamA + ghost < maxCapacity) {
            return game.teamIdA;
        }

        const countTeamB = game.gamePlayers.filter((obj: any) => obj.teamId === game.teamIdB).length;

        if (countTeamB + ghost < maxCapacity) {
            return game.teamIdB;
        }
    } else {
        const countTeamB = game.gamePlayers.filter((obj: any) => obj.teamId === game.teamIdB).length;

        if (countTeamB + ghost < maxCapacity) {
            return game.teamIdB;
        }

        const countTeamA = game.gamePlayers.filter((obj: any) => obj.teamId === game.teamIdA).length;

        if (countTeamA + ghost < maxCapacity) {
            return game.teamIdA;
        }
    }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ghostGameTotal = (game, sport) => {
    if (!game) {
        return;
    }
    if (sport === 'padel') {
        return game.gameReservedPlayer;
    }
    const gameId = game.gameId;
    const maxCapacity = game.gameMaxCapacity;
    const reservedPlayer = game.gameReservedPlayer;
    const halfCapacity = Math.round(maxCapacity / 2);
    const caseGameId = gameId.charAt(gameId.length - 1).toUpperCase();
    let caseSelect = casesGhost[caseGameId];
    const totalCase = caseSelect.length;
    const totalGuest = caseSelect.map((v) => v.guests).reduce((sum, current) => sum + current, 0);
    let total = totalCase + totalGuest;
    let caseSelect2 = caseSelect;
    while (total > halfCapacity) {
        caseSelect2 = caseSelect2.map((c) => {
            if (c.guests === 0) {
                return c;
            }
            return {
                ...c,
                guests: c.guests - 1,
            };
        });
        const totalCase2 = caseSelect2.length;
        const totalGuest2 = caseSelect2.map((v) => v.guests).reduce((sum, current) => sum + current, 0);
        if (totalGuest2 === 0 && totalCase2 > halfCapacity) {
            caseSelect2.pop();
        }
        total = totalCase2 + totalGuest2;
    }
    if (total > 1 && maxCapacity <= 6 && total === halfCapacity) {
        //solo quitar un jugador mas si ma capacidad maxima es menor 0 igual a 6
        //solo si el total de jugadores fantasma representa la mitad
        //solo si el total de jugadores iniciales es par
        // esto para que loo hagas en algunos casos quede 1/4 o 2/4

        if (totalCase % 2 !== 0) {
            caseSelect2.pop();
        }
    }
    caseSelect = caseSelect2;
    if (reservedPlayer < halfCapacity) {
        if (caseSelect && caseSelect.length > 0) {
            const totalCase = caseSelect.length;
            let totalGuest = 0;
            if (totalCase > 0) {
                totalGuest = caseSelect.map((v) => v.guests).reduce((sum, current) => sum + current, 0);
            }
            const total = totalCase + totalGuest + reservedPlayer;
            return total;
        } else {
            return reservedPlayer;
        }
    } else {
        return reservedPlayer;
    }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ghostGame = (game, sport) => {
    console.log('Aui****', sport);
    if (!game) {
        return;
    }
    if (sport === 'padel') {
        return game;
    }
    const gameId = game.id;
    const maxCapacity = game.maxCapacity;
    const reservedPlayer = game.reservedPlayer;
    const halfCapacity = Math.round(maxCapacity / 2);
    if (gameId && gameId.length === 0) {
        return;
    }
    if (gameId) {
        const caseGameId = gameId.charAt(gameId.length - 1).toUpperCase();
        let caseSelect = casesGhost[caseGameId];
        const totalCase = caseSelect.length;
        const totalGuest = caseSelect.map((v) => v.guests).reduce((sum, current) => sum + current, 0);
        let total = totalCase + totalGuest;
        let caseSelect2 = caseSelect;
        const urlFileGhost = `${process.env.REACT_APP_URL_FILE}ghost/${sport}/`;

        // console.log(totalCase % 2 === 0 ? 'eS PAR LE PUDE QUITAR UNO' : 'ES IMPAR QUEDA IGUAL');
        // console.log({ total, caseSelect });
        while (total > halfCapacity) {
            console.log('ente ***', { total, halfCapacity });
            caseSelect2 = caseSelect2.map((c) => {
                if (c.guests === 0) {
                    return c;
                }
                return {
                    ...c,
                    guests: c.guests - 1,
                };
            });
            const totalCase2 = caseSelect2.length;
            const totalGuest2 = caseSelect2.map((v) => v.guests).reduce((sum, current) => sum + current, 0);
            if (totalGuest2 === 0 && totalCase2 > halfCapacity) {
                caseSelect2.pop();
            }
            // console.log({ totalCase2, totalGuest2 });
            total = totalCase2 + totalGuest2;
            // console.log(JSON.stringify({ total, halfCapacity, caseSelect2 }));
        }
        if (total > 1 && maxCapacity <= 6 && total === halfCapacity) {
            //solo quitar un jugador mas si ma capacidad maxima es menor 0 igual a 6
            //solo si el total de jugadores fantasma representa la mitad
            //solo si el total de jugadores iniciales es IMpar
            // esto para que loo hagas en algunos casos quede 1/4 o 2/4

            if (totalCase % 2 !== 0) {
                caseSelect2.pop();
            }
        }
        caseSelect = caseSelect2;
        // console.log({ total, halfCapacity, caseSelect, caseSelect2 });

        if (reservedPlayer < halfCapacity) {
            if (caseSelect && caseSelect.length > 0) {
                //console.log({ caseSelect, gameId });

                const team = [];
                caseSelect.map((c, i) => {
                    for (let index = 0; index < c.guests + 1 && team.length + reservedPlayer <= maxCapacity; index++) {
                        const urlPhoto = `${urlFileGhost}${caseGameId}_${i}.png`;
                        const teamId = getTeamIdToJoin(game, team.length - 1, i);
                        const newGamePlayer = {
                            teamId: teamId,
                            gameId: gameId,
                            invited: c.guests,
                            playerId: uuidv4(),
                            name: index === 0 ? c.player : `Invitado de ${c.player}`,
                            status: 'PENDING',
                            photo: urlPhoto,
                        };
                        team.push(newGamePlayer);
                    }
                });
                const playerGhostA = team.filter((obj: any) => obj.teamId === game.teamIdA);
                const playerGhostB = team.filter((obj: any) => obj.teamId === game.teamIdB);
                const newGame = {
                    ...game,
                    reservedGhost: team.length,
                    playersTeamA: [...game.playersTeamA, ...playerGhostA],
                    playersTeamB: [...game.playersTeamB, ...playerGhostB],
                };
                return newGame;
            } else {
                return game;
            }
        } else {
            return game;
        }
    }
};
